import { convertTo62 } from './convertTo62';
import { convertToUUID } from './convertToUUID';
import { UUID_BASE62 } from './constants';

/** @deprecated use convertToUUID instead */
export function convertIdToUUID(id: string) {
  return id.length === UUID_BASE62.length ? convertToUUID(id) : convertTo62(id);
}
